export default "__VITE_ASSET__DqgqutfH__"